import React, { createContext, useContext, useState, useRef } from "react";
import GlobalSnackbar from "./GlobalSnackbar";

const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {

    const [snackbar, setSnackbar] = useState({
        show: false,
        message: "",
        type: "error",
        id: 0
    });

    const timerRef = useRef(null);

    const showSnackbar = (message, type = "error") => {

        // Clear old timer if exists
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        // Update state with new id (forces animation restart)
        setSnackbar(prev => ({
            show: true,
            message,
            type,
            id: prev.id + 1
        }));

        // Start new timer
        timerRef.current = setTimeout(() => {
            setSnackbar(prev => ({
                ...prev,
                show: false
            }));
        }, 3000);
    };

    return (
        <SnackbarContext.Provider value={{ showSnackbar }}>
            {children}
            <GlobalSnackbar snackbar={snackbar} />
        </SnackbarContext.Provider>
    );
};

export const useSnackbar = () => useContext(SnackbarContext);
